import React from 'react';
import dynamic from 'next/dynamic';
import * as PropTypes from 'prop-types';
import { get_ } from 'sf-modules';
import HeaderBlog from '@/yema-designkit/webkit/organisms/HeaderBlog';
import Meta from 'components/Meta';
import * as Paths from 'constants/paths';

const Footer = dynamic(() => import('@/yema-designkit/webkit/organisms/Footer'), { ssr: false });

const Maintenance = dynamic(() => import('@/yema-designkit/webkit/layouts/Maintenance'), {
    ssr: false,
});

const BlogLayout = ({ className, staticContent, children, ...otherProps }) => {
    if (staticContent && staticContent.withError) return <Maintenance />;

    return (
        <>
            <div className={className} {...otherProps}>
                <Meta {...staticContent.metaTags} />
                <div>
                    <HeaderBlog blogUrl='/blog' storeUrl={process.env.NEXT_PUBLIC_URL} />

                    <main>{children}</main>

                    <Footer
                        className=''
                        type='full'
                        navigation={get_(staticContent, ['pageNavigations', 'footerMenu'], [])}
                        facebookUrl={Paths.YEMA_FACEBOOK}
                        instagramUrl={Paths.YEMA_INSTAGRAM}
                        twitterUrl={Paths.YEMA_TWITTER}
                        whatsappUrl={Paths.YEMA_WHATSAPP}
                    />
                </div>
            </div>

            {staticContent.preview && (
                <div
                    className='fixed bottom-0 flex w-full justify-between bg-brand-primary-500 px-6 py-2 font-body shadow-up'
                    style={{ fontSize: '12px', zIndex: '9999' }}
                >
                    Preview mode
                    <a href='/api/preview/end'>Exit preview mode</a>
                </div>
            )}
        </>
    );
};

BlogLayout.defaultProps = {
    className: 'page',
    staticContent: {},
};

BlogLayout.propTypes = {
    className: PropTypes.string,
    staticContent: PropTypes.object,
};

export default BlogLayout;
